import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import api from '../../axios';

const initialState = {
    groups: [],
    currentGroup: {}
}

export const retrieveGroups = createAsyncThunk(
    'dashboard/retrieveGroups',
    async (thunkAPI) => {
        try {
            const response = await api.post('/group/list', {});
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue({error: error.message});
        }
    }
);

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveGroups.fulfilled, (state, action) => {
                state.groups = action.payload;
                state.currentGroup = action.payload[0];
            })
            .addCase(retrieveGroups.rejected, (state) => {
                // implement error handling logic
            });
    },
})

export default dashboardSlice.reducer